<script lang="ts" setup>
type CrumbConfig = {
  icon?: string;
  name: string;
  route?: string;
  value?: any;
  styleClasses?: string;
}
const props = defineProps<{
  config: CrumbConfig[]
}>();

const emit = defineEmits<{
  (e: 'input', value: any): void
}>()

function isFirst(index: number) {
  return index === 0
}

function isLast(index: number) {
  return index === props.config.length - 1
}

function isMid(index: number) {
  return !isFirst(index) && !isLast(index)
}
</script>
<template>
  <nav class="ribbon w-full flex flex-wrap">
    <a 
      v-for="(crumb, $index) in config" 
      :key="$index"
      :route="crumb.route" 
      class="ribbon-item -ml-1 mt-2 py-1 pl-6 pr-2 font-bold flex items-center gap-1 relative rounded-lg hover:text-gray-200 hover:underline"
      :class="[
        crumb.styleClasses,
        {
          'bg-gray-900 text-white pl-2 pr-4': isFirst($index),
          'bg-gray-600 text-white pr-4 pl-[1rem]': isMid($index),
          'pr-4 pl-[1rem]': isLast($index),
        }
      ]"
      @click="emit('input', crumb.value)"
    >
      <SparkIcon class="inline-block " v-if="crumb.icon" size="10" :icon="crumb.icon" />
      {{ crumb.name }}
    </a>
  </nav>
</template>
<style lang="scss" scoped>
$arrow-length: 9px;


.ribbon-item:not(:first-child):not(:last-child) {
  clip-path: polygon(0 0,
      $arrow-length 50%,
      0 100%,
      calc(100% - $arrow-length) 100%,
      100% 50%,
      calc(100% - $arrow-length) 0);
}


.ribbon-item:last-child {
  clip-path: polygon(0 0,
      $arrow-length 50%,
      0 100%,
      100% 100%,
      100% 0)
}

.ribbon-item:first-child {
  clip-path: polygon(0 0,
      0 100%,
      calc(100% - $arrow-length) 100%,
      100% 50%,
      calc(100% - $arrow-length) 0);
}
</style>
